import { combineReducers, createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import rootSaga from 'sagas';
import ui from './ui';
import onboarding from './onboarding';

const persistConfig = {
  key: 'objectToPersist',
  storage,
  whitelist: [],
};

// create the saga middleware
const sagaMiddleware = createSagaMiddleware();

// eslint-disable-next-line no-underscore-dangle
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const mainReducer = combineReducers({
  ui,
  onboarding,
});

const pReducer = persistReducer(persistConfig, mainReducer);

export const store = createStore(pReducer, composeEnhancers(applyMiddleware(sagaMiddleware)));

export const persistor = persistStore(store);

// run the saga
sagaMiddleware.run(rootSaga);
